import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { resetPassword } from 'aws-amplify/auth'
import { Link } from 'react-router-dom'
import MainNav from '../components/MainNav'
import FormPage from '../components/FormPage'
import FormContainer from '../components/FormContainer'
import FormLabel from '../components/FormLabel'
import Button from '../components/Button'
import styled from 'styled-components/macro'
import ErrorMessage from '../components/ErrorMessage'
import Footer from '../components/Footer'
import FormValidator, { ERROR_CODE } from '../components/FormValidator'
import { CONFIRMATION_TYPES } from '../constants/confirmationConstants'

const LinkContainer = styled.div`
  margin-top: 20px;

  > a {
    text-decoration: none;
    color: ${props => props.theme.colorText};
    font-size: ${props => props.theme.fontSizeSmall};
  }
`

const errorMessages = {
  [ERROR_CODE.UserNotFound]: 'Salasanan nollaus epäonnistui.',
  [ERROR_CODE.UserNotValidated]: 'Salasanaa ei voida nollata, koska käyttäjätunnusta ei ole vahvistettu tai sitä ei ole olemassa.',
  UnknownError: 'Salasanan nollaus epäonnistui. Yritä myöhemmin uudelleen.'
}

const getResetPasswordErrorCode = err => {
  const rawCode = err?.name || err?.code || err?.__type
  const knownCodes = Object.keys(errorMessages)

  if (rawCode) {
    // Some SDK errors include a prefix format such as "x#UserNotFoundException"
    const normalizedCode = rawCode.includes('#') ? rawCode.split('#').pop() : rawCode
    return knownCodes.includes(normalizedCode) ? normalizedCode : 'UnknownError'
  }

  const message = (err?.message || '').toLowerCase()
  if (message.includes('not found') || message.includes('does not exist')) {
    return ERROR_CODE.UserNotFound
  }
  if (message.includes('not confirmed') || message.includes('not verified')) {
    return ERROR_CODE.UserNotValidated
  }
  if (message.includes('authenticated')) {
    return 'UnknownError'
  }

  return 'UnknownError'
}

const ResetAccountPassword = ({ history }) => {
  const [username, setUsername] = useState('')
  const [errorCodes, setErrorCodes] = useState([])
  const [errorPayload, setErrorPayload] = useState({})

  useEffect(() => {
    document.title = 'Business Joensuu -  Vaihda salasana'
  }, [])

  const internalResetPassword = async () => {
    setErrorCodes([])
    try {
      await resetPassword({ username })
      history.push(`/confirm-account?confirmationType=${CONFIRMATION_TYPES.PASSWORD}`)
    } catch (err) {
      const errorCode = getResetPasswordErrorCode(err)
      setErrorCodes([errorCode])
      console.error(err)
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    internalResetPassword()
  }

  return (
    <>
      <FormPage>
        <MainNav history={history} />
        <FormContainer onSubmit={handleSubmit}>
          <FormValidator
            messages={errorMessages}
            codes={errorCodes}
            onChange={setErrorPayload}
          >
            <h1>Salasanan palautus</h1>
            <p>
              Kirjoita tunnuksesi sähköposti, johon lähetämme vahvistuskoodin
              uutta salasanaa varten.
            </p>
            <FormLabel hasErrorMessage>
              Sähköposti
              <input
                type="email"
                onChange={event => setUsername(event.target.value)}
              />
            </FormLabel>
            <ErrorMessage
              codes={errorCodes}
              payload={errorPayload}
            />
            <Button isPrimary isFullWidth type="submit">
              Lähetä
            </Button>
            <LinkContainer>
              <Link to="/login">Takaisin kirjautumiseen</Link>
            </LinkContainer>
          </FormValidator>
        </FormContainer>
      </FormPage>
      <Footer />
    </>
  )
}

ResetAccountPassword.propTypes = {
    history: PropTypes.object
}

export default ResetAccountPassword
